// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as PlaceOrderRepoConfig from "./PlaceOrderRepoConfig.bs.js";
import * as PlaceOrderPayloadApiModel from "../api-model/PlaceOrderPayloadApiModel.bs.js";
import * as PlaceOrderCouponPayloadEntityMapper from "../entity-mapper/PlaceOrderCouponPayloadEntityMapper.bs.js";
import * as VehicleQuotationPayloadEntityMapper from "../entity-mapper/VehicleQuotationPayloadEntityMapper.bs.js";

var fetchLocationBoundsPath = Config.Env.getHostName(undefined) + "/crm/place_order/geo_region_bounds";

var fetchRestrictionBoundsPath = Config.Env.getHostName(undefined) + "/crm/place_order/restrictions";

var fetchVehicleDetailsPath = Config.Env.getHostName(undefined) + "/crm/place_order/vehicle_infos";

var fetchVehicleQuotationPath = Config.Env.getHostName(undefined) + "/crm/place_order/quotations";

var fetchCouponListPath = Config.Env.getCrmGatewayUrl(undefined) + "/crm/place_order/offers";

var placeOrderPath = Config.Env.getHostName(undefined) + "/crm/place_order/create_trip";

var applyCouponPath = Config.Env.getHostName(undefined) + "/crm/place_order/apply_coupon";

var removeCouponPath = Config.Env.getHostName(undefined) + "/crm/place_order/remove_coupon";

function fetchLocationBounds(geo_region_id, country) {
  var requestUrl = fetchLocationBoundsPath + "?geo_region_id=" + geo_region_id;
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country),
                    "is-crm-order": true
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.LocationBoundsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchRestrictionBounds(geo_region_id, country) {
  var requestUrl = fetchRestrictionBoundsPath + "?geo_region_id=" + geo_region_id;
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country),
                    "is-crm-order": true
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.RestrictionBoundsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchVehicleDetails(geo_region_id, latLng, mobile, country) {
  var lat = String(latLng.lat);
  var lng = String(latLng.lng);
  var requestUrl = fetchVehicleDetailsPath + "?geo_region_id=" + geo_region_id + "&lat=" + lat + "&long=" + lng + "&mobile=" + mobile;
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country),
                    "crm-order-key": Config.Env.crm_oder_key,
                    "is-crm-order": true
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.VehicleDetailsResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchVehicleQuotation(payload, country) {
  var payload$1 = JSON.stringify(VehicleQuotationPayloadEntityMapper.execute(payload));
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.post(fetchVehicleQuotationPath, {
                    country: CountryConfig.countryToString(country),
                    "crm-order-key": Config.Env.crm_oder_key,
                    "is-crm-order": true
                  }, payload$1, undefined, /* Include */2, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.VehicleQuotationsResponseConverter.execute, result);
                            });
                }), fetchVehicleQuotationPath);
}

function fetchCouponList(geo_region_id, pickupLatLng, dropLatLng, customer_id, country, order_id) {
  var pickup_lat = String(pickupLatLng.lat);
  var pickup_long = String(pickupLatLng.lng);
  var drop_lat = String(dropLatLng.lat);
  var drop_long = String(dropLatLng.lng);
  var requestUrl = fetchCouponListPath + "?geo_region_id=" + geo_region_id + "&pickup_lat=" + pickup_lat + "&pickup_long=" + pickup_long + "&drop_lat=" + drop_lat + "&drop_long=" + drop_long + "&customer_id=" + customer_id + "&parent_order_id=" + order_id;
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country),
                    "is-crm-order": true,
                    "crm-order-key": Config.Env.crm_oder_key
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.CouponListResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function placeOrder(payload, country) {
  var finalData = PlaceOrderPayloadApiModel.t_encode(payload);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.post(placeOrderPath, {
                    country: CountryConfig.countryToString(country),
                    "is-crm-order": true,
                    "crm-order-key": Config.Env.crm_oder_key
                  }, JSON.stringify(finalData), undefined, /* Include */2, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.PlaceOrderResponseConverter.execute, result);
                            });
                }), placeOrderPath);
}

function applyCoupon(payload, country) {
  var payload$1 = JSON.stringify(PlaceOrderCouponPayloadEntityMapper.execute(payload));
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.post(applyCouponPath, {
                    country: CountryConfig.countryToString(country),
                    "crm-order-key": Config.Env.crm_oder_key,
                    "is-crm-order": true
                  }, payload$1, undefined, /* Include */2, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.VehicleQuotationsResponseConverter.execute, result);
                            });
                }), applyCouponPath);
}

function removeCoupon(payload, country) {
  var payload$1 = JSON.stringify(VehicleQuotationPayloadEntityMapper.execute(payload));
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.post(removeCouponPath, {
                    country: CountryConfig.countryToString(country),
                    "crm-order-key": Config.Env.crm_oder_key,
                    "is-crm-order": true
                  }, payload$1, undefined, /* Include */2, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.VehicleQuotationsResponseConverter.execute, result);
                            });
                }), removeCouponPath);
}

var PlaceOrderRepo = {
  fetchLocationBounds: fetchLocationBounds,
  fetchRestrictionBounds: fetchRestrictionBounds,
  fetchVehicleDetails: fetchVehicleDetails,
  fetchVehicleQuotation: fetchVehicleQuotation,
  fetchCouponList: fetchCouponList,
  placeOrder: placeOrder,
  applyCoupon: applyCoupon,
  removeCoupon: removeCoupon
};

export {
  PlaceOrderRepo ,
  
}
/* fetchLocationBoundsPath Not a pure module */
